import { z } from "zod/v4";

import { userSchema } from "@/schemas/user";

const contentItemSchema = z.object({
  text: z.string(),
  type: z.string(),
  // status: z.enum([""]),
});

const contentSchema = z.object({
  content: z.array(contentItemSchema),
  version: z.string(),
});

export const commentSchema = z.object({
  id: z.string(),
  comment: z.string().nullable(),
  content: contentSchema,
  is_resolved: z.boolean(),
  resolved_by: userSchema.nullable().optional(),
  resolved_at: z.string().nullable(),
  is_shared_with_borrower: z.boolean(),
  commentable_type: z.string(),
  commentable_id: z.string(),
  created_at: z.string(),
});

export type Comment = z.infer<typeof commentSchema>;
